// Quality Signals — Common Threads explorer API client.
// Backend: app/routes/signals_reports.py GET /api/admin/signals/threads.

import api from './api';

export interface ThreadSignal {
  id: string;
  customer: string;
  account_id: string | null;
  observation: string;
  significance: string;
  themes: string[];
  sku: string | null;
  signal_type: string;
  source_channel: string;
  observed_by: string;
  observed_at: string | null;
  confidence: number;
  order_id: string | null;
  batch_id: string | null;
  // metadata-contract additions (PR #1440)
  customer_no: string | null;
  status: string;
  sage_so_no: string | null;
  quality_issue_id: string | null;
  related_signal_ids: string[];
}

// Which field the signals are clustered ("sliced") by.
export type ClusterBy =
  | 'thread'
  | 'customer'
  | 'account'
  | 'sku'
  | 'theme'
  | 'signal_type'
  | 'source_channel'
  | 'status';

export interface Thread {
  id: string;
  title: string;
  customer: string;
  account_id: string | null;
  theme: string;
  count: number;
  severity: 'critical' | 'high' | 'watch';
  last_seen_days: number | null;
  skus: string[];
  themes: string[];
  members: ThreadSignal[];
  // slice metadata + cross-cutting rollups
  cluster_by: ClusterBy;
  key: string;
  customers: string[];
  signal_types: string[];
  statuses: string[];
}

export interface ThreadStats {
  signals: number;
  threads: number;
  customers: number;
  recurring: number;
  top_customer: string | null;
}

export interface ThreadsResponse {
  threads: Thread[];
  stats: ThreadStats;
  cluster_by: ClusterBy;
  slices: ClusterBy[];
}

export interface ThreadsParams {
  cluster_by?: ClusterBy;
  customer?: string;
  theme?: string;
  sku?: string;
  days?: number;
}

const BASE = '/admin/signals/threads';

export const signalsThreadsApi = {
  list: async (params?: ThreadsParams): Promise<ThreadsResponse> => {
    const r = await api.get<ThreadsResponse>(BASE, { params });
    return r.data;
  },
};
